import React from 'react'
import { getId } from '../twd'

export default ({field, form, error, ...props}) => {
    const id = getId()

    let err = form.errors && form.errors[field.name]

    return (
    <div className={'form-group ' + (err || error ? ' has-error': '')}>
    <input type="number"
        className='form-control vertical-offset-xxs'
        id={id}
        name={field.name}
        value={field.value}
        step="0.001"
        {...field}
        {...props}
        {...(err || error ? {"aria-invalid":true} : {})}
        onChange={(e) =>{
            form.setFieldValue(field.name, e.target.value || '')
        }}
        />
    { err && <label className="field-status has-error">{err}</label> }
    </div>)
}


// WEBPACK FOOTER //
// ./src/twd/fields/number.js